import React, { useEffect, useState } from "react";
import ModalDisplay from "../Partials/ModalDisplay";
import Div from "../../components/common/Div";
import Text from "../../components/common/Text";
import { tenzero } from "../../constants/Constants";
import { Typography } from "@mui/material";

export default function LoadingBox(props) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  let displayValue = "none";
  if (props.display) displayValue = "block";

  const spinnerStyle = {
    border: "16px solid rgb(33, 42, 65)",
    borderRadius: "50%",
    borderTop: "16px solid #ffffff",
    width: "60px",
    height: "60px",
    animation: "spin 2s linear infinite",
  };

  const spinKeyframes = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  return (
    <ModalDisplay
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: windowWidth >= 800 ? "40%" : "80%",
        padding: "2rem",
        backgroundColor: "rgb(33, 42, 65)",
        boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
        borderRadius: "12px",
      }}
      display={displayValue}
    >
      <style>{spinKeyframes}</style>

      <Div margin={tenzero} style={{ textAlign: "center" }}>
        <div style={spinnerStyle}></div>
      </Div>
      <Div margin={tenzero} style={{ textAlign: "center", marginTop: "1rem" }}>
        <Typography
          color={"rgb(33, 42, 65)"}
          style={{ fontSize: "1.5rem", fontWeight: "bold" }}
        >
          Loading
        </Typography>
      </Div>
    </ModalDisplay>
  );
}
